import styled from '@emotion/styled'

import { CONFIG } from '@/styles/emotion.config'

export const MediaCategoryItemStyles = styled.div(() => ({
  borderRadius: 'var(--radii-default)',
  width: '100%',
  '& .container': {
    height: '100%',
    display: 'grid',
    gridTemplateAreas: '"media description"',
  },

  '& .container + .container': {
    marginTop: '5rem',
  },

  '& .container--has_button': {
    gridTemplateAreas: '"media description" "media button"',
  },

  '& .container--right': {
    gridTemplateAreas: '"description media"',
  },

  '& .container--right .media': {
    marginLeft: 'auto',
  },

  '& .container--has_button.container--right': {
    gridTemplateAreas: '"description media" "button media"',
  },

  '& .media': {
    height: '100%',
    minWidth: '22rem',
    width: '100%',
    gridArea: 'media',
    gridTemplateColumns: '1fr 22rem',
    borderRadius: 'var(--radii-default)',
    display: 'flex',
    justifyContent: 'center',
  },

  '& .media__content': {
    width: '100%',
    margin: '0 auto',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },

  '& .content': {
    width: '100%',
    maxWidth: '25rem',
    gridArea: 'description',
    gridTemplateColumns: '1fr 25rem',
    alignSelf: 'center',
    marginLeft: '1.5rem',
    wordBreak: 'break-word',
  },

  '& .container--has_button .content': {
    alignSelf: 'flex-end',
  },

  '& .content .title': {
    marginBottom: '0.5rem',
  },

  '& .cta_container': {
    width: '100%',
    maxWidth: '25rem',
    gridArea: 'button',
    marginTop: '1rem',
    marginLeft: '1.5rem',
  },

  [CONFIG.media.mobileSm]: {
    '& .media': {
      width: '100%',
    },
  },
  [CONFIG.media.mobileXs]: {
    '& .media': {
      minWidth: '100%',
    },
  },
  [CONFIG.media.mobileLg]: {
    minHeight: '31.5rem',
    '& .container': {
      justifyItems: 'center',
    },

    '& .container + & .container': {
      marginTop: '2.5rem',
    },

    '& .container, & .container--right': {
      display: 'grid',
      gridTemplateColumns: '1fr',
      margin: '0 auto',
      padding: '0',
      gridTemplateAreas: `"description" "media"`,
    },

    '& .container--has_button, & .container--has_button.container--right': {
      gridTemplateAreas: `"description" "media" "button"`,
    },

    '& .media': {
      margin: '1rem auto 0',
    },

    '& .container:not(.container--has_button) .media, & .cta_container': {
      alignSelf: 'flex-end',
    },

    '& .cta_container': {
      display: 'flex',
      justifyContent: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
    },

    '& .cta_container .button': {
      display: 'block',
      width: '100%',
      maxWidth: '22.5rem',
    },

    '& .content, & .container--right': {
      marginLeft: '0',
      marginRight: '0',
    },
  },
}))
